<template>
	<div>
		<i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>

		<section v-if="!loading" class="forms">
			<div class="page-header">
				<h3 class="page-title">
					{{ location.name }}
				</h3>

				<nav aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<router-link :to="{ name: 'locations' }"
								>Einrichtungen</router-link
							>
						</li>
						<li class="breadcrumb-item active" aria-current="page">Detail</li>
					</ol>
				</nav>
			</div>

			<div
				v-if="location.notice && location.notice.length > 0"
				class="alert alert-primary"
				role="alert"
			>
				{{ location.notice }}
			</div>

			<div
				v-if="last_login"
				style="font-size: 11px; display: block; margin-bottom: 10px"
			>
				Letzter Login: {{ last_login.updated_at | moment(' D.MM.YYYY hh:mm') }}
			</div>
			<div class="row">
				<div class="col-md-3 stretch-card grid-margin">
					<div class="card bg-gradient-danger card-img-holder text-white">
						<div class="card-body">
							<h4 class="font-weight-normal mb-3">
								Aktive Kinder
								<i class="mdi mdi-human-child mdi-24px float-right"></i>
							</h4>
							<h2 class="">{{ childs_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-md-3 stretch-card grid-margin">
					<div class="card bg-gradient-warning card-img-holder text-white">
						<div class="card-body">
							<h4 class="font-weight-normal mb-3">
								Alle Kinder
								<i class="mdi mdi-human-child mdi-24px float-right"></i>
							</h4>
							<h2 class="">{{ inactive_childs_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-md-3 stretch-card grid-margin">
					<div class="card bg-gradient-info card-img-holder text-white">
						<div class="card-body">
							<h4 class="font-weight-normal mb-3">
								Mitarbeiter
								<i
									class="mdi mdi-clipboard-account-outline mdi-24px float-right"
								></i>
							</h4>
							<h2 class="">{{ staff_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
				<div class="col-md-3 stretch-card grid-margin">
					<div class="card bg-gradient-success card-img-holder text-white">
						<div class="card-body">
							<h4 class="font-weight-normal mb-3">
								App Nutzer
								<i class="mdi mdi-cellphone-text mdi-24px float-right"></i>
							</h4>
							<h2 class="">{{ users_count }}</h2>
							<h6 class="card-text"></h6>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12 stretch-card grid-margin">
					<div class="card">
						<div class="card-body">
							<h4 class="card-title"></h4>
							<b-tabs>
								<b-tab title="Account" active>
									<div class="card">
										<div class="card-body">
											<h4 class="card-title">
												Account [{{ location.kindy_id }}]
											</h4>
											<a
												:href="'https://' + location.subdomain + '.kindy.cloud'"
												target="_blank"
												>{{ location.subdomain }}.kindy.cloud</a
											>
											<div>{{ location.slot }}</div>

											<p class="card-description"></p>

											<div style="text-align: right">
												<b-button
													v-if="!loading_account"
													@click="btnLocation($event)"
													type="submit"
													variant="success"
													class="mr-2"
													>Speichern</b-button
												>
											</div>

											<form class="forms-sample">
												<b-form-group label="Tags" label-for="input1">
													<b-form-tags
														input-id="tags-basic"
														placeholder=""
														v-model="location.account_tags"
													></b-form-tags>
													<!--<p class="mt-2">Value: {{ location.tags }}</p> -->
												</b-form-group>

												<b-form-group label="Anmerkung" label-for="input1">
													<b-form-input
														v-model="location.notice"
														type="text"
														id="input1"
														placeholder="Anmerkung"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Standort" label-for="input1">
													<b-form-input
														v-model="location.name"
														type="text"
														id="input1"
														placeholder="Standort"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Träger" label-for="inputCategory">
													<b-form-input
														v-model="location.category"
														type="text"
														id="inputCategory"
														placeholder="Träger"
													></b-form-input>
												</b-form-group>

												<b-form-group
													label="Rechnungs Alert"
													label-for="input11alert"
												>
													<b-form-select
														v-model="location.billing_alert"
														:options="options_billingalert"
													/>
												</b-form-group>
												<b-form-group label="Status" label-for="input11">
													<b-form-select
														v-model="location.account_state"
														:options="options_state"
													/>
												</b-form-group>
												<b-form-group
													label="Testzeitraum bis"
													label-for="input113"
													v-if="location.account_state == 'test'"
												>
													<date-picker
														v-model="location.test_until"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group
													label="Kunde seit"
													label-for="input115"
													v-if="location.account_state == 'customer'"
												>
													<date-picker
														v-model="location.customer_until"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group
													label="Kündigung zum"
													label-for="input115"
													v-if="location.account_state == 'customer'"
												>
													<date-picker
														v-model="location.cancellation_at"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group label="Kindy ID" label-for="input4">
													<b-form-input
														v-model="location.kindy_id"
														type="text"
														id="input4"
														placeholder="Kindy ID"
													></b-form-input>
												</b-form-group>

												<b-form-group label="Subdomain" label-for="input6">
													<b-form-input
														v-model="location.subdomain"
														type="text"
														id="input6"
														placeholder="Subdomain"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Adresse" label-for="input3">
													<b-form-input
														v-model="location.address"
														type="text"
														id="input3"
														placeholder="Adresse"
													></b-form-input>
												</b-form-group>
												<b-form-group label="E-Mail" label-for="input9">
													<b-form-input
														v-model="location.email"
														type="text"
														id="input9"
														placeholder="E-Mail"
													></b-form-input>
												</b-form-group>
												<b-form-group label="Telefonnummer" label-for="input7">
													<b-form-input
														v-model="location.phone"
														type="text"
														id="input7"
														placeholder="Telefonnummer"
													></b-form-input>
												</b-form-group>

												<b-form-group
													label="Feature Mode"
													label-for="inputFeatureMode"
												>
													<b-form-checkbox
														v-model="location.feature_mode"
														id="inputFeatureMode"
														:value="true"
														:unchecked-value="false"
														switch
													>
														{{
															location.feature_mode
																? 'Aktiviert'
																: 'Deaktiviert'
														}}
													</b-form-checkbox>
												</b-form-group>

												<div style="text-align: right">
													<b-button
														v-if="!loading_account"
														@click="btnLocation($event)"
														type="submit"
														variant="success"
														class="mr-2"
														>Speichern</b-button
													>
												</div>
												<!--
                        <b-button
                          @click="btnRemoveLocation($event)"
                          type="button"
                          variant="danger"
                          class="float-right mr-2"
                          >Löschen</b-button
                        >
                        -->
											</form>
										</div>
									</div>
								</b-tab>
								<b-tab title="Stammdaten">
									<div class="card">
										<div class="card-body">
											<h4 class="card-title">Stammdaten</h4>
											<p class="card-description"></p>
											<form class="forms-sample">
												<b-form-group label="Notizen" label-for="inputC10">
													<b-form-textarea
														v-model="location_base.notes"
														id="inputC10"
														placeholder="Notizen"
														:rows="10"
													></b-form-textarea>
												</b-form-group>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Nächste Abrechnung"
															label-for="input115"
															v-if="location.account_state == 'customer'"
														>
															<date-picker
																v-model="location_base.next_settlement"
																valueType="format"
																:format="dateFormat"
																placeholder="Datum wählen"
															></date-picker>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="SEPA-Lastschriftmandat"
															label-for="input11alert"
														>
															<b-form-select
																v-model="location_base.billing_sepa"
																:options="options_billingalert"
															/>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Rabatt (%)"
															label-for="inputCT1"
														>
															<b-form-input
																v-model="location_base.discount"
																type="text"
																id="inputCT1"
																placeholder="0"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="Abrechnung Laufzeit in Monaten"
															label-for="inputCT2"
														>
															<b-form-input
																v-model="location_base.duration"
																type="text"
																id="inputCT2"
																placeholder="1"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div
													class="mt-2 mb-4"
													style="width: 100%;border-top: 1px solid #666666;"
												></div>
												<h5 class="mt-3 mb-3">Anschrift</h5>
												<b-form-group label="Einrichtung" label-for="inputC3">
													<b-form-input
														v-model="location_base.name"
														type="text"
														id="inputC3"
														placeholder="Einrichtung"
													></b-form-input>
												</b-form-group>

												<div class="row">
													<div class="col-md-4">
														<b-form-group
															label="Firmenname"
															label-for="inputC2"
														>
															<b-form-input
																v-model="location_base.company"
																type="text"
																id="inputC2"
																placeholder="Firmenname"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Nachname" label-for="inputC2">
															<b-form-input
																v-model="location_base.lastname"
																type="text"
																id="inputC2"
																placeholder="Nachname"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Name" label-for="inputC1">
															<b-form-input
																v-model="location_base.firstname"
																type="text"
																id="inputC1"
																placeholder="Name"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-4">
														<b-form-group label="Zusatz 1" label-for="inputC2">
															<b-form-input
																v-model="location_base.lineOne"
																type="text"
																placeholder="Zusatz 1"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Zusatz 2" label-for="inputC1">
															<b-form-input
																v-model="location_base.lineTwo"
																type="text"
																placeholder="Zusatz 2"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-4">
														<b-form-group label="Zusatz 3" label-for="inputC4">
															<b-form-input
																v-model="location_base.lineThree"
																type="text"
																placeholder="Zusatz 3"
															></b-form-input>
														</b-form-group>
													</div>
												</div>

												<div class="row">
													<div class="col-md-6">
														<b-form-group label="Straße" label-for="inputC4">
															<b-form-input
																v-model="location_base.street"
																type="text"
																id="inputC4"
																placeholder="Straße"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6"></div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group label="PLZ" label-for="inputC5">
															<b-form-input
																v-model="location_base.zip"
																type="text"
																id="inputC5"
																placeholder="PLZ"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group label="Ort" label-for="inputC6">
															<b-form-input
																v-model="location_base.city"
																type="text"
																id="inputC6"
																placeholder="Ort"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Rechnungsadresse für PDF"
															label-for="inputC6"
														>
															<b-form-textarea
																v-model="location_base.billing_address"
																id="inputC10"
																placeholder="Rechnungsadresse"
																:rows="4"
															></b-form-textarea>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group
															label="Rechnungs E-Mail"
															label-for="inputC7"
														>
															<b-form-input
																v-model="location_base.email"
																type="text"
																id="inputC7"
																placeholder="E-Mail"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<div
													class="mt-2 mb-4"
													style="width: 100%;border-top: 1px solid #666666;"
												></div>
												<h5 class="mt-3 mb-3">Lastschrift</h5>
												<div class="row">
													<div class="col-md-6">
														<b-form-group
															label="Lastschriftmandat"
															label-for="inputCT5"
														>
															<b-form-input
																v-model="location_base.sepa"
																type="text"
																id="inputCT5"
																placeholder="Mandat"
															></b-form-input>
														</b-form-group>
													</div>
													<div class="col-md-6">
														<b-form-group label="IBAN" label-for="inputCT6">
															<b-form-input
																v-model="location_base.iban"
																type="text"
																id="inputCT6"
																placeholder="DEXXXX"
															></b-form-input>
														</b-form-group>
													</div>
												</div>
												<b-button
													v-if="!loading_base"
													@click="btnLocationBase($event)"
													type="submit"
													variant="success"
													class="mr-2"
													>Speichern</b-button
												>
											</form>
										</div>
									</div>
								</b-tab>
								<b-tab title="Dokumente">
									<vue-dropzone
										ref="imgDropZone1"
										id="customdropzone1"
										:options="dropzoneOptions1"
										@vdropzone-complete="afterComplete"
										@vdropzone-success="afterSuccess"
									></vue-dropzone>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in documents" :key="item.uid">
													<td>{{ item.created_at | moment(' D.MM.YYYY') }}</td>
													<td>{{ item.file_name }}</td>
													<td style="text-align: right">
														<a
															:href="item.file"
															target="_blank"
															class="btn btn-outline-primary btn-fw"
															>Download</a
														>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Produkte">
									<b-button
										style="margin-bottom: 20px"
										@click="
											openModalProduct({
												product_id: 0,
												amout: 0,
											})
										"
										variant="success"
										v-b-modal.modalmd9
										class="mr-2"
										>Neues Produkt</b-button
									>
									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Bezeichnung</th>
													<th>Preis</th>
													<th>Anzahl</th>
													<th></th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in products" :key="item.uid">
													<td>{{ item.name }}</td>
													<td>{{ item.price }} Euro</td>
													<td>{{ item.amout }}</td>
													<td>
														<!-- Modal starts -->
														<div class="text-center">
															<b-btn
																v-b-modal.modalmd9
																variant="primary"
																@click="openModalProduct(item)"
																>Details</b-btn
															>
														</div>
													</td>

													<td style="text-align: right">
														<!--  <router-link class="btn btn-outline-primary btn-fw" :to="{ name: 'location-detail', params: { uid: item.uid }}" >Anzeigen</router-link> -->
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Rechnungen">
									<b-button
										style="margin-bottom: 20px"
										@click="btnAddBilling($event)"
										type="submit"
										variant="success"
										class="mr-2"
										>Neue Rechnung</b-button
									>

									<div class="alert alert-primary" v-show="create_pdf_loader">
										Erstelle PDF ...
									</div>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Re-Nr.</th>
													<th>Datum</th>
													<th>Zeitraum</th>

													<th>Netto</th>
													<th>Brutto</th>
													<th>Bezahlt</th>
													<th>E-Mail</th>
													<th></th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in billings" :key="item.uid">
													<td>
														<i
															@click="generatePdf(item)"
															style="cursor: pointer; margin-right: 5px"
															class="mdi mdi-file-pdf mdi-24px"
														></i>
														<span v-if="!item.download_file">{{
															item.invoice_nr
														}}</span>
														<a
															v-if="item.download_file"
															:href="item.download_file"
															target="_blank"
															>{{ item.invoice_nr }}</a
														>
													</td>
													<td>{{ item.invoice_date }}</td>
													<td>
														{{ item.invoice_range_from }}<br />{{
															item.invoice_range_to
														}}
													</td>

													<td>
														<span v-if="item.cancel_invoice" style="color: red"
															>-
															{{
																(item.invoice_amount / 100) | toCurrency
															}}</span
														>
														<span
															v-if="!item.cancel_invoice"
															style="color: green"
														>
															{{
																(item.invoice_amount / 100) | toCurrency
															}}</span
														>
													</td>

													<td>
														<span v-if="item.cancel_invoice" style="color: red"
															>-
															{{
																((item.invoice_amount / 100) * 1.19)
																	| toCurrency
															}}</span
														>
														<span
															v-if="!item.cancel_invoice"
															style="color: green"
														>
															{{
																((item.invoice_amount / 100) * 1.19)
																	| toCurrency
															}}</span
														>
													</td>

													<td>
														<div v-if="item.paid">
															<span v-if="item.cancel_invoice"
																>Storno RE-{{ item.cancel_invoice_nr }}</span
															>
															<span v-if="!item.cancel_invoice">Ja</span>
															<br />
															{{ item.paid_at }}
														</div>
													</td>
													<td>
														<div v-if="item.emailsend">
															Ja<br />
															{{ item.emailsend_at }}
														</div>
													</td>
													<td>
														<div
															v-for="tag in item.tags"
															:key="tag"
															class="badge-container"
														>
															<span class="badge-tag">{{ tag }}</span>
														</div>
													</td>
													<td style="text-align: right">
														<!-- Modal starts -->
														<div class="text-center">
															<b-btn
																v-b-modal.modalmd
																variant="primary sm"
																@click="openModal(item)"
																>Details</b-btn
															>
														</div>
													</td>
												</tr>
											</tbody>
										</table>

										<b-modal id="modalmd" title="Details" size="md" ok-only @>
											<form class="forms-sample">
												<div style="text-align: right">
													<div @click="cancelInvoice()" class="btn btn-link">
														Stornorechnung anlegen
													</div>
												</div>

												<!--
                        <b-form-group
                          label="Rechnung verschickt"
                          label-for="emailsend"
                        >
                          <input
                            type="checkbox"
                            id="emailsend"
                            name="emailsend"
                            v-model="current_item.emailsend"
                          />
                        </b-form-group>
                        -->
												<b-form-group
													label="Rechnung verschickt am "
													label-for=""
												>
													<date-picker
														v-model="current_item.emailsend_at"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group label="Empfänger" label-for="input2">
													<b-form-input
														type="text"
														id="input2"
														v-model="email_receiver"
													></b-form-input>
												</b-form-group>

												<div @click="sendInvoice()" class="btn btn-link">
													Rechnung senden
												</div>
												<b-alert
													v-if="emailSend"
													variant="primary"
													style="margin-top: 20px"
													show
													>E-Mail gesendet ({{ emailStatus }})</b-alert
												>

												<b-form-group label="Bezahlt am" label-for="">
													<date-picker
														v-model="current_item.paid_at"
														valueType="format"
														:format="dateFormat"
														placeholder="Datum wählen"
													></date-picker>
												</b-form-group>
												<b-form-group label="Tags" label-for="">
													<b-form-tags
														input-id="tags-basic"
														placeholder=""
														v-model="current_item.tags"
													></b-form-tags>
												</b-form-group>
												<b-button
													variant="success"
													@click="saveEmailDetails()"
													class="mr-2"
													>Speichern</b-button
												>

												<b-alert
													v-if="modalSaved1"
													variant="primary"
													style="margin-top: 20px"
													show
													>Gespeichert</b-alert
												>
											</form>
										</b-modal>

										<b-modal id="modalmd9" title="Produkte" size="md" ok-only @>
											<form class="forms-sample">
												<b-form-group label="Status" label-for="input11">
													<b-form-select
														v-model="current_item.product_id"
														:options="product_list_dp"
													/>
												</b-form-group>

												<b-form-group label="Anzahl" label-for="input4">
													<b-form-input
														v-model="current_item.amout"
														type="text"
														id="input4"
														placeholder="Anzahl"
													></b-form-input>
												</b-form-group>

												<b-button
													variant="success"
													@click="saveProductDetails()"
													class="mr-2"
													>Speichern</b-button
												>
												<b-button @click="removeProductDetails()" class="mr-2"
													>Löschen</b-button
												>
											</form>
										</b-modal>

										<!-- Modal Ends -->
									</div>
								</b-tab>
								<b-tab title="Ablage">
									<vue-dropzone
										ref="imgDropZone2"
										id="customdropzone2"
										:options="dropzoneOptions2"
										@vdropzone-complete="afterComplete"
										@vdropzone-success="afterSuccess"
									></vue-dropzone>

									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>

													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in invoices" :key="item.uid">
													<td>{{ item.created_at | moment(' D.MM.YYYY') }}</td>
													<td>{{ item.file_name }}</td>
													<td style="text-align: right">
														<a
															:href="item.file"
															target="_blank"
															class="btn btn-outline-primary btn-fw"
															>Download</a
														>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</b-tab>
								<b-tab title="Mitarbeiter">
									<table class="table">
										<thead>
											<tr>
												<th>Vorname</th>
												<th>Nachname</th>
												<th>Zugangsart</th>
												<th>E-Mail</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="item in staff_list" :key="item.uid">
												<td>
													{{ item.firstname }}
													<!--
                          <div v-if="location.kenc">
                            <a target="_blank"
                              :href="'http://www.kindy.app/unmask-test-call?slot=' + location.slot + '&str=' + encodeURIComponent(item.firstname)">Unmask</a>
                          </div>
                          -->
												</td>
												<td>
													{{ item.lastname }}
												</td>
												<td>
													<b-form-select
														v-model="item.access_type"
														:options="options_pin"
														@change="updatePin(item)"
														size="sm"
														style="max-width: 150px;"
													></b-form-select>
												</td>
												<td>
													{{ item.email }}
												</td>
												<td>
													<span v-if="item.access_type == 'email_pin'">{{
														item.activated
													}}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script lang="js">

import Vue from 'vue';
import moment from 'moment';

import dropzone from 'vue2-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';

// https://github.com/rowanwins/vue-dropzone

//let uuid = require("uuid");
import {
  getLocation,
  updateLocation,
  removeLocation,
  updateInvoiceInfo,
  sendInvoice,
  getLocationDocuments,
  addBilling,
  updateProduct,
  createPdf,
  cancelInvoice,
  updateLocationBase,
  updateStaffAccess
} from '@/services/locations.service';

export default {
  name: 'basicFormsElements',
  components: {
    DatePicker,
    vueDropzone: dropzone
  },
  data() {
    return {
      modalSaved1: false,
      emailStatus: null,
      emailSend: false,
      email_receiver: "",
      invoice_uid: null,
      current_item: {},
      file: null,
      create_pdf_loader: false,
      location: {},
      products: [],
      childs_count: 0,
      inactive_childs_count: 0,
      users_count: 0,
      staff_count: 0,
      documents: [],
      invoices: [],
      billings: [],
      last_login: null,
      staff_list: [],
      loading: true,
      location_base: {},
      loading_account: false,
      loading_base: false,
      loading_remove: false,
      dateFormat: 'DD.MM.YYYY',
      options_billingalert: [
        { value: 'n', text: 'Nein' },
        { value: 'y', text: 'Ja' }

        //{ value: 'd', text: 'This one is disabled', disabled: true }
      ],
      options_state: [
        { value: null, text: '' },
        { value: 'test', text: 'Test' },
        { value: 'customer', text: 'Kunde' },
        { text: "Kostenlose Nutzung", value: "forfree" },
        { value: 'close', text: 'Geschlossen' },
        //{ value: 'd', text: 'This one is disabled', disabled: true }
      ],
      options_pin: [
        { value: 'pin', text: 'PIN' },
        { value: 'email_pin', text: 'E-Mail PIN' }
      ],
      dropzoneOptions1: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'document' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
      dropzoneOptions2: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'invoice' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
    }
  },
  computed: {
    document_list: function () {
      return this.$store.state.locations
    },
    product_list_dp: function () {

      let m = []

      for (let k = 0; k < this.$store.state.allProducts.length; k++) {

        m.push(
          { value: this.$store.state.allProducts[k].product_id, text: this.$store.state.allProducts[k].name + " (" + this.$store.state.allProducts[k].price / 100 + ")" }
        )

      }

      return m

    }
  },
  mounted() {

    this.loading = true

    getLocation(this.$route.params.uid).then((resp) => {

      if (resp.data.error) {
        if (resp.data.error == 'location') {
          this.$router.push({ name: 'locations' })
        }

        if (resp.data.error == 'user') {
          localStorage.removeItem('token')
          this.$router.push({ name: 'login' })
        }
      }
      else {

        console.log("resp", resp.data)

        this.$store.state.user_customer = resp.data.customer
        this.$store.state.user_company = resp.data.company

        if (this.$store.state.user_customer) {
          this.$router.push({ name: 'locations' })
        }
        else {
          this.location = resp.data.location


          if (this.location.created_at) {
            this.location.created_at = moment(this.location.created_at).format('DD.MM.YYYY');
          }

          this.dropzoneOptions1.params.loc_id = this.location.loc_id
          this.dropzoneOptions2.params.loc_id = this.location.loc_id

          this.dropzoneOptions1.params.location_uid = this.$route.params.uid
          this.dropzoneOptions2.params.location_uid = this.$route.params.uid

          this.location_base = resp.data.location_base

          this.childs_count = resp.data.childs_count
          this.inactive_childs_count = resp.data.childs_inactive_count
          this.staff_count = resp.data.staff_count
          this.users_count = resp.data.users_count

          this.last_login = resp.data.last_login

          this.billings = resp.data.billings


          this.products = resp.data.products

          this.$store.state.allProducts = resp.data.all_products

          this.invoices = resp.data.entries_invoices
          this.documents = resp.data.entries_documents

          this.staff_list = resp.data.staff_list

          this.loading = false
        }
      }

    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });




  },
  methods: {
    generatePdf: function (item) {


      this.create_pdf_loader = true

      createPdf(item).then(data => {

        this.billings = data.data.billings
        this.create_pdf_loader = false
      })
    },
    saveEmailDetails: function () {

      if (this.current_item.paid_at) {
        this.current_item.paid = true
      }
      else {
        this.current_item.paid = false
      }

      if (this.current_item.emailsend_at) {
        this.current_item.emailsend = true
      }
      else {
        this.current_item.emailsend = false
      }

      updateInvoiceInfo({
        current_item: this.current_item,

      }).then((data) => {
        this.modalSaved1 = true


        if (data.data.billings) {
          this.billings = data.data.billings
        }
      })

    },
    cancelInvoice: function () {
      this.$swal({
        title: '',
        text: "Soll eine Stornorechnung angelegt werden?",
        showCancelButton: true,
        confirmButtonColor: '#30b3f6',
        cancelButtonColor: '#7F8FA4',
        cancelButtonText: 'Abbrechen',
        confirmButtonText: 'Ja, anlegen.'
      }).then((result) => {
        if (result.value) {

          console.log("oh ja")

          cancelInvoice({
            id: this.current_item._id,
            location_uid: this.current_item.location_uid
          }).then((data) => {
            console.log("oh ja", data)

            this.billings = data.data.billings
          })
        }
      })




    },
    sendInvoice: function () {
      console.log(this.email_receiver, this.current_item._id, this.current_item.location_uid)

      let ref = this

      sendInvoice({
        email: this.email_receiver,
        id: this.current_item._id,
        location_uid: this.current_item.location_uid
      }).then((data) => {

        this.emailStatus = data.data.status
        this.emailSend = true

        setTimeout(() => {
          ref.emailSend = false
        }, 3000);

      })
    },
    removeProductDetails: function () {

      updateProduct({ remove: true, location_uid: this.location.uid, item: this.current_item }).then((resp) => {

        if (resp.data && resp.data.products) {
          this.products = resp.data.products
        }
      })

    },
    saveProductDetails: function () {

      updateProduct({ location_uid: this.location.uid, item: this.current_item }).then((resp) => {
        console.log()
        if (resp.data && resp.data.products) {
          this.products = resp.data.products
        }


      })

    },
    openModalProduct: function (item) {


      this.current_item = item
    },

    openModal: function (item) {
      this.modalSaved1 = false
      this.email_receiver = this.location_base.email
      this.current_item = item
    },
    btnAddBilling: function (ev) {
      ev.preventDefault()

      addBilling({ location_uid: this.location.uid }).then((resp) => {
        console.log(resp)
        this.billings = resp.data.billings
      })
    },
    btnRemoveLocation: function (ev) {
      ev.preventDefault()


      this.$swal({
        title: '',
        text: "Soll dieser Account wirklich gelöscht werden?",
        showCancelButton: true,
        confirmButtonColor: '#30b3f6',
        cancelButtonColor: '#7F8FA4',
        cancelButtonText: 'Abbrechen',
        confirmButtonText: 'Ja, löschen.'
      }).then((result) => {
        if (result.value) {
          this.loading_remove = true
          removeLocation({ uid: this.location.uid }).then((resp) => {
            this.$store.state.locations = resp.data.locations
            Vue.$toast.open({
              message: 'Gelöscht',
              type: 'success',
              position: 'bottom',
              duration: 1500
            });

            this.$router.push({ name: 'locations', params: {} })
          })

        }
      })
    },

    openAccount: function () {
      window.open("https://" + this.location.subdomain + ".kindy.cloud?email=hallo", "_blank");
    },
    btnLocation: function (ev) {
      ev.preventDefault()
      this.loading_account = true
      updateLocation(this.location).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_account = false
      })
    },
    btnLocationBase: function (ev) {
      ev.preventDefault()

      this.location_base.location_uid = this.$route.params.uid

      if (this.location_base.next_settlement) {
        this.location_base.next_settlement_stamp = moment(this.location_base.next_settlement, "DD.MM.YYYY").format()
      }


      this.loading_base = true
      updateLocationBase(this.location_base).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_base = false
      })
    },
    async afterSuccess(file, response) {
      console.log(file, response.data.cat)

      getLocationDocuments({
        loc_id: this.location.loc_id,
        location_uid: this.$route.params.uid,
        cat: response.data.cat
      }).then((data) => {

        if (data.data.cat == 'document') {
          this.documents = data.data.entries
        }
        if (data.data.cat == 'invoice') {
          this.invoices = data.data.entries
        }

      })

    },
    async afterComplete(upload) {
      //var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        //let file = upload;
        //console.log(file)

        //var storageRef = firebase.storage().ref();
        //var imageRef = storageRef.child(`images/${imageName}.png`);
        //await imageRef.put(file, metadata);
        //var downloadURL = await imageRef.getDownloadURL();
        //this.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone1.removeFile(upload);
      this.$refs.imgDropZone2.removeFile(upload);
    },
    updatePin: function(staffItem) {
      updateStaffAccess({
        location_uid: this.location.uid,
        staff_uid: staffItem.uid,
        access_type: staffItem.access_type
      }).then((resp) => {
        if (resp.data && resp.data.staff_list) {
          this.staff_list = resp.data.staff_list
        }
        Vue.$toast.open({
          message: 'Zugangsart aktualisiert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
      }).catch((error) => {
        Vue.$toast.open({
          message: 'Fehler beim Aktualisieren der Zugangsart',
          type: 'error',
          position: 'bottom',
          duration: 2000
        });
        console.error('Error updating access type:', error);
      })
    }
  }
}
</script>

<style scoped>
.dropzone {
	margin-bottom: 50px;
	min-height: auto !important;
}
</style>

<style>
.badge-secondary {
	background-color: #198ae3;
	border-color: #198ae3;
	font-size: 13px;

	color: #ffffff;
	padding: 7px 14px 10px 12px;
}

.badge-secondary .text-truncate {
	margin-right: 5px;
}

.b-form-tag {
	font-size: 14px;
}

.badge-container {
	margin-bottom: 5px;
}

.badge-tag {
	color: #ffffff;
	background-color: #198ae3;
	padding: 4px 5px 4px 5px;
	font-size: 12px;
	display: inline-block;
}
</style>
